import React from 'react';
import { useAppSettingsStore } from '../../stores/appSettingsStore';

const ThemeToggle: React.FC<{ className?: string; label?: string }> = ({ className, label = 'Toggle dark mode' }) => {
  const { darkMode, toggleTheme } = useAppSettingsStore();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={className ?? `p-2 rounded-xl bg-background dark:bg-background-dark
                border border-borderGrey dark:border-borderGrey-dark
                text-text dark:text-text-dark
                transition-all duration-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-backgroundGreen/20 dark:focus:ring-backgroundGreen-dark/20 focus:border-backgroundGreen`}
      aria-label={label}
      title={label}
    >
      {darkMode ? (
        <svg className="w-5 h-5 text-text-dark dark:text-text-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ) : (
        <svg className="w-5 h-5 text-primary dark:text-primary-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;